import e from "./index834.js";
import o from "./index826.js";
import r from "./index827.js";
var a = r && r.isTypedArray, s = a ? o(a) : e;
export {
  s as default
};
